import { render, staticRenderFns } from "./my-extension.vue?vue&type=template&id=c6c97df6&"
import script from "./my-extension.vue?vue&type=script&lang=js&"
export * from "./my-extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports